import { OnInit, Input, Component, Output, EventEmitter } from '@angular/core';
import { Payment } from '@app/shared/models/payment';
import { CasePaymentUriBuilderParams, PaymentService } from '@app/core/services/case-payment.service';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { PaymentType } from '@app/shared/models/payment-type';
import { PaymentReceiver } from '@app/shared/models/payment-receiver';
import { PaymentDialogComponent } from '@app/modules/case/components/payment-dialog/payment-dialog.component';
import { BaseUpdateComponent } from '@app/shared/components/base/base-update.component';

@Component({
    selector: '[case-lawyer-payment-line-editable]',
    templateUrl: './case-lawyer-payment-line-editable.component.html',
    styleUrls: ['./case-lawyer-payment-line-editable.component.scss']
})

export class CaseLawyerPaymentLineEditableComponent extends BaseUpdateComponent<Payment, CasePaymentUriBuilderParams>
                                                    implements OnInit {

    protected paramsIdNames = ['id'];

    @Input()
    public caseId: string;

    @Input()
    public paymentTypes: PaymentType[];

    @Input()
    public paymentReceivers: PaymentReceiver[];

    @Output()
    public delete = new EventEmitter<Payment>();

    public colorCode = 'default';

    get payment() {
        return this.updated;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected paymentService: PaymentService) {
        super(componentServiceBundle, paymentService);
    }

    public ngOnInit() {
        this.patchParams = {
            urlSuffix: this.payment.id
        };

        this.updateColorCode();
    }

    public editPayment(): void {
        const dialogRef = this.dialog.open(PaymentDialogComponent, {
            width: '800px',
            disableClose: true,
            autoFocus: false,
            data: {
                payment: this.payment,
                paymentTypes: this.paymentTypes,
                paymentReceivers: this.paymentReceivers
            }
        });

        dialogRef.afterClosed()
                 .subscribe(updatedPayment => {
             if (updatedPayment) {
                 this.update(null, () => {
                     this.updateColorCode();
                 }, null, updatedPayment);
             }
        });
    }

    public removePayment(): void {
        this.delete.emit(this.payment);
    }

    public updateColorCode(): void {
        if (!this.payment.received_percentage && this.payment.received_percentage !== 0) {
            this.colorCode = 'default';
        } else if (this.payment.received_percentage <= 0 || this.payment.received_percentage > 100) {
            this.colorCode = 'red';
        } else if (this.payment.received_percentage === 100) {
            if (this.payment.outstanding && this.payment.outstanding !== 0) {
                this.colorCode = 'yellow';
            } else {
                this.colorCode = 'green';
            }
        } else {
            this.colorCode = 'yellow';
        }
    }

    protected generateUriBuilderParams(): CasePaymentUriBuilderParams {
        return new CasePaymentUriBuilderParams(this.caseId);
    }
}
